function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import APIContainersService from '../api/service/Containers';
import * as modelMapper from '../mappers/dto-to-model';
import * as dtoMapper from '../mappers/model-to-dto';
import * as DMS from '../models';
import { assert, assertEquals, assertRequired } from '../common/assert';
import { mapMerge } from '../common/map-util';
import ItemService from './item-service';
import { projectOrFolderType } from '../mappers/model-to-dto';
function assertFolderOrProject(key) {
  assert(key.type === DMS.ItemType.Folder || key.type === DMS.ItemType.Project, 'Invalid containerType (expected Folder or Project)', true, key.type, key.id);
}
function assertContainerType(key, type) {
  assertEquals(key.type, type, 'Invalid container type', true, key);
}
var ContainerService = /*#__PURE__*/function (_ItemService) {
  function ContainerService(http) {
    var _this;
    _classCallCheck(this, ContainerService);
    _this = _callSuper(this, ContainerService, [http]);
    _this.apiContainersService = void 0;
    _this.apiContainersService = new APIContainersService(_this.http);
    return _this;
  }
  _inherits(ContainerService, _ItemService);
  return _createClass(ContainerService, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(key, bundleId) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              assertFolderOrProject(key);
              return _context.abrupt("return", key.type === DMS.ItemType.Folder ? this.getFolder(key, bundleId) : this.getProject(key, bundleId, undefined, true));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "getFolder",
    value: function () {
      var _getFolder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key, bundleId, suppressErrors) {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.apiFoldersService.get_ById(key.id, {
                suppressErrors: suppressErrors,
                bundleId: bundleId
              });
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", modelMapper.folder(response.body));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getFolder(_x3, _x4, _x5) {
        return _getFolder.apply(this, arguments);
      }
      return getFolder;
    }()
  }, {
    key: "getProject",
    value: function () {
      var _getProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key, bundleId, suppressErrors) {
        var getScheduleItems,
          response,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              getScheduleItems = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
              _context3.next = 3;
              return this.apiProjectsService.getProject(key.id, {
                getScheduleItems: getScheduleItems
              }, {
                suppressErrors: suppressErrors,
                bundleId: bundleId
              });
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", modelMapper.project(response.body));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProject(_x6, _x7, _x8) {
        return _getProject.apply(this, arguments);
      }
      return getProject;
    }()
  }, {
    key: "getShares",
    value: function () {
      var _getShares = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(key) {
        var _yield$response$body$;
        var response, shares;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              assertFolderOrProject(key);
              response = key.type === DMS.ItemType.Folder ? this.apiFoldersService.getFolderPermissions(key.id) : this.apiProjectsService.getProjectPermissions(key.id);
              _context4.next = 4;
              return response;
            case 4:
              _context4.t1 = _yield$response$body$ = _context4.sent.body.containerPermissions;
              _context4.t0 = _context4.t1 !== null;
              if (!_context4.t0) {
                _context4.next = 8;
                break;
              }
              _context4.t0 = _yield$response$body$ !== void 0;
            case 8:
              if (!_context4.t0) {
                _context4.next = 12;
                break;
              }
              _context4.t2 = _yield$response$body$;
              _context4.next = 13;
              break;
            case 12:
              _context4.t2 = [];
            case 13:
              shares = _context4.t2;
              return _context4.abrupt("return", shares.map(modelMapper.share));
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getShares(_x9) {
        return _getShares.apply(this, arguments);
      }
      return getShares;
    }()
  }, {
    key: "getAllShares",
    value: function () {
      var _getAllShares = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(containerKeys) {
        var _this2 = this;
        var keyMap, containersByType, promises, results;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              keyMap = new Map();
              containersByType = containerKeys.reduce(function (map, key) {
                keyMap.set(key.id, key);
                assertFolderOrProject(key);
                if (!map.has(key.type)) {
                  map.set(key.type, new Set());
                }
                map.get(key.type).add(key.id);
                return map;
              }, new Map());
              promises = Array.from(containersByType.entries(), /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref) {
                  var _ref3, type, ids, keys;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _ref3 = _slicedToArray(_ref, 2), type = _ref3[0], ids = _ref3[1];
                        keys = Array.from(ids, function (id) {
                          return keyMap.get(id);
                        });
                        return _context5.abrupt("return", _this2.getAllSharesByType(type, keys));
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x11) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context6.next = 5;
              return Promise.all(promises);
            case 5:
              results = _context6.sent;
              return _context6.abrupt("return", mapMerge.apply(void 0, _toConsumableArray(results)));
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function getAllShares(_x10) {
        return _getAllShares.apply(this, arguments);
      }
      return getAllShares;
    }()
  }, {
    key: "addShare",
    value: function () {
      var _addShare = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(key, share, cascade, notify) {
        var dto;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              assertFolderOrProject(key);
              dto = dtoMapper.addPermissionsCriteria(share, cascade, notify);
              return _context7.abrupt("return", key.type === DMS.ItemType.Folder ? this.apiFoldersService.addPermissionsAsync(key.id, dto) : this.apiProjectsService.addPermissionsAsync(key.id, dto));
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function addShare(_x12, _x13, _x14, _x15) {
        return _addShare.apply(this, arguments);
      }
      return addShare;
    }()
  }, {
    key: "removeShare",
    value: function () {
      var _removeShare = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(key, userId, cascade) {
        var params;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              assertFolderOrProject(key);
              params = {
                cascade: cascade
              };
              return _context8.abrupt("return", key.type === DMS.ItemType.Folder ? this.apiFoldersService.removePermissionsAsync(key.id, userId, params) : this.apiProjectsService.removePermissionsAsync(key.id, userId, params));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function removeShare(_x16, _x17, _x18) {
        return _removeShare.apply(this, arguments);
      }
      return removeShare;
    }() // eslint-disable-next-line max-params
  }, {
    key: "getChildren",
    value: function () {
      var _getChildren = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(key, view, page) {
        var _view$sort;
        var includeFiles,
          includeTrashed,
          countDocuments,
          calculateLocks,
          bundleId,
          params,
          projects,
          response,
          _args9 = arguments;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              includeFiles = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : true;
              includeTrashed = _args9.length > 4 && _args9[4] !== undefined ? _args9[4] : false;
              countDocuments = _args9.length > 5 && _args9[5] !== undefined ? _args9[5] : false;
              calculateLocks = _args9.length > 6 && _args9[6] !== undefined ? _args9[6] : true;
              bundleId = _args9.length > 7 ? _args9[7] : undefined;
              params = {
                from: page.pageNumber,
                pageSize: page.itemCount,
                sort: dtoMapper.sort((_view$sort = view.sort) !== null && _view$sort !== void 0 ? _view$sort : new DMS.Sort()),
                containersOnly: !includeFiles,
                trashed: includeTrashed,
                countDocuments: countDocuments,
                calculateLocks: calculateLocks
              };
              if (!(key.type === DMS.ItemType.Client)) {
                _context9.next = 11;
                break;
              }
              _context9.next = 9;
              return this.getClientChildren(key);
            case 9:
              projects = _context9.sent;
              return _context9.abrupt("return", new DMS.ItemPage(projects, DMS.Page.fromPageNumber(1, projects.length)));
            case 11:
              _context9.next = 13;
              return this.apiContainersService.getChildren(projectOrFolderType(key.type), key.id, params, {
                bundleId: bundleId
              });
            case 13:
              response = _context9.sent;
              return _context9.abrupt("return", modelMapper.itemPage(response.body, modelMapper.item));
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getChildren(_x19, _x20, _x21) {
        return _getChildren.apply(this, arguments);
      }
      return getChildren;
    }()
  }, {
    key: "getClientChildren",
    value: function () {
      var _getClientChildren = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(client) {
        var response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              assertContainerType(client, DMS.ItemType.Client);

              // TODO: Move to model-to-dto mapper
              _context10.next = 3;
              return this.apiProjectsService.get({
                primaryAssociationId: client.id,
                primaryAssociationType: 'Client',
                // We need "schedule items" for application type ID
                getScheduleItems: true
              });
            case 3:
              response = _context10.sent;
              return _context10.abrupt("return", response.body.map(modelMapper.project));
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getClientChildren(_x22) {
        return _getClientChildren.apply(this, arguments);
      }
      return getClientChildren;
    }()
  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(parent, name) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (name.trim()) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return", false);
            case 2:
              return _context11.abrupt("return", parent.type === DMS.ItemType.Client ? this.projectExists(parent, name) : this.folderExists(parent, name));
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function exists(_x23, _x24) {
        return _exists.apply(this, arguments);
      }
      return exists;
    }()
  }, {
    key: "createFolder",
    value: function () {
      var _createFolder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(parent, name) {
        var inheritPermissions,
          request,
          response,
          _args12 = arguments;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              inheritPermissions = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : false;
              assertFolderOrProject(parent);

              // TODO: Move to model-to-dto mapper
              request = {
                parentId: parent.id,
                parentType: projectOrFolderType(parent.type),
                name: name
              };
              _context12.next = 5;
              return this.apiFoldersService.post({
                inheritPermissions: inheritPermissions
              }, request);
            case 5:
              response = _context12.sent;
              return _context12.abrupt("return", modelMapper.container(response.body));
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function createFolder(_x25, _x26) {
        return _createFolder.apply(this, arguments);
      }
      return createFolder;
    }() // eslint-disable-next-line max-params
  }, {
    key: "createProject",
    value: function () {
      var _createProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(parent, name, template, year) {
        var isTemplate,
          _args13 = arguments;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              isTemplate = _args13.length > 4 && _args13[4] !== undefined ? _args13[4] : false;
              assertContainerType(parent, DMS.ItemType.Client);
              assert(!template || !isTemplate, 'Cannot create template from template', true, template, parent);
              return _context13.abrupt("return", template ? this.createProjectFromTemplate(parent, name, template, year) : this.createAndGetProject(parent, name, year, isTemplate));
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function createProject(_x27, _x28, _x29, _x30) {
        return _createProject.apply(this, arguments);
      }
      return createProject;
    }()
  }, {
    key: "deleteProjectFromTrash",
    value: function () {
      var _deleteProjectFromTrash = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(trashId) {
        var params;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              params = {
                skipCheckpointCanDeleteCheck: false
              };
              _context14.next = 3;
              return this.apiTrashService.deleteProject(trashId, params);
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function deleteProjectFromTrash(_x31) {
        return _deleteProjectFromTrash.apply(this, arguments);
      }
      return deleteProjectFromTrash;
    }()
  }, {
    key: "moveFolder",
    value: function () {
      var _moveFolder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(folder, target, renameOnConflict) {
        var name, dto;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              name = folder.name;
              _context15.next = 3;
              return this.exists(target, name);
            case 3:
              if (!_context15.sent) {
                _context15.next = 9;
                break;
              }
              if (renameOnConflict) {
                _context15.next = 6;
                break;
              }
              throw new Error('File name is not available');
            case 6:
              _context15.next = 8;
              return this.getUniqueName(target, folder.name);
            case 8:
              name = _context15.sent;
            case 9:
              dto = dtoMapper.moveFolder(folder.id, name, target);
              _context15.next = 12;
              return this.apiFoldersService.put(folder.id, dto);
            case 12:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function moveFolder(_x32, _x33, _x34) {
        return _moveFolder.apply(this, arguments);
      }
      return moveFolder;
    }()
  }, {
    key: "moveFolders",
    value: function () {
      var _moveFolders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(folders, target) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return Promise.all(folders.map(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(folder) {
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        return _context16.abrupt("return", _this3.moveFolder(folder, target));
                      case 1:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x37) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function moveFolders(_x35, _x36) {
        return _moveFolders.apply(this, arguments);
      }
      return moveFolders;
    }()
  }, {
    key: "copyFolder",
    value: function () {
      var _copyFolder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(folder, target, renameOnConflict) {
        var name, dto, response;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              name = folder.name;
              _context18.next = 3;
              return this.exists(target, name);
            case 3:
              if (!_context18.sent) {
                _context18.next = 9;
                break;
              }
              if (renameOnConflict) {
                _context18.next = 6;
                break;
              }
              throw new Error('File name is not available');
            case 6:
              _context18.next = 8;
              return this.getUniqueName(target, folder.name);
            case 8:
              name = _context18.sent;
            case 9:
              dto = dtoMapper.copyFolder(name, target);
              _context18.next = 12;
              return this.apiFoldersService.copy(folder.id, dto);
            case 12:
              response = _context18.sent;
              return _context18.abrupt("return", response.body);
            case 14:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function copyFolder(_x38, _x39, _x40) {
        return _copyFolder.apply(this, arguments);
      }
      return copyFolder;
    }()
  }, {
    key: "copyFolders",
    value: function () {
      var _copyFolders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(folders, target) {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", Promise.all(folders.map(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(folder) {
                  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                    while (1) switch (_context19.prev = _context19.next) {
                      case 0:
                        return _context19.abrupt("return", _this4.copyFolder(folder, target));
                      case 1:
                      case "end":
                        return _context19.stop();
                    }
                  }, _callee19);
                }));
                return function (_x43) {
                  return _ref5.apply(this, arguments);
                };
              }())));
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      function copyFolders(_x41, _x42) {
        return _copyFolders.apply(this, arguments);
      }
      return copyFolders;
    }()
  }, {
    key: "getUniqueName",
    value: function () {
      var _getUniqueName = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(container, name) {
        var counter,
          newName,
          used,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              counter = _args21.length > 2 && _args21[2] !== undefined ? _args21[2] : 1;
              newName = "".concat(name, " (").concat(counter, ")");
              _context21.next = 4;
              return this.exists(container, name);
            case 4:
              used = _context21.sent;
              if (used) {
                _context21.next = 7;
                break;
              }
              return _context21.abrupt("return", newName);
            case 7:
              return _context21.abrupt("return", this.getUniqueName(container, name, counter + 1));
            case 8:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getUniqueName(_x44, _x45) {
        return _getUniqueName.apply(this, arguments);
      }
      return getUniqueName;
    }()
    /**
     * Project POST only returns the new project ID, so this also gets the project metadata since the consumer will expect it. This also brings it inline with create folder and create project from template
     */
  }, {
    key: "createAndGetProject",
    value: (function () {
      var _createAndGetProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(parent, name, year) {
        var isTemplate,
          request,
          response,
          key,
          _args22 = arguments;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              isTemplate = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : false;
              assertContainerType(parent, DMS.ItemType.Client);
              request = dtoMapper.createProject(parent, name, year, isTemplate);
              _context22.next = 5;
              return this.apiProjectsService.post1({}, request);
            case 5:
              response = _context22.sent;
              key = new DMS.ContainerKey(response.body, DMS.ItemType.Project);
              return _context22.abrupt("return", this.get(key));
            case 8:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function createAndGetProject(_x46, _x47, _x48) {
        return _createAndGetProject.apply(this, arguments);
      }
      return createAndGetProject;
    }())
  }, {
    key: "createProjectFromTemplate",
    value: function () {
      var _createProjectFromTemplate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(parent, name, template) {
        var year,
          request,
          response,
          _args23 = arguments;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              year = _args23.length > 3 && _args23[3] !== undefined ? _args23[3] : 1900;
              assertContainerType(parent, DMS.ItemType.Client);
              request = dtoMapper.createProject(parent, name, year);
              _context23.next = 5;
              return this.apiProjectsService.copy(template.id, {}, request);
            case 5:
              response = _context23.sent;
              return _context23.abrupt("return", modelMapper.project(response.body));
            case 7:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function createProjectFromTemplate(_x49, _x50, _x51) {
        return _createProjectFromTemplate.apply(this, arguments);
      }
      return createProjectFromTemplate;
    }()
  }, {
    key: "folderExists",
    value: function () {
      var _folderExists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(parent, name) {
        var response, result;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return this.apiFoldersService.foldersExists({
                containerId: parent.id,
                containerType: projectOrFolderType(parent.type),
                folderNames: [name]
              });
            case 2:
              response = _context24.sent;
              result = response.body[0];
              return _context24.abrupt("return", !!result.exists && new DMS.ContainerKey(result.id, DMS.ItemType.Folder));
            case 5:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function folderExists(_x52, _x53) {
        return _folderExists.apply(this, arguments);
      }
      return folderExists;
    }()
  }, {
    key: "projectExists",
    value: function () {
      var _projectExists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(client, name) {
        var year,
          response,
          result,
          _args25 = arguments;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              year = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : 1900;
              _context25.next = 3;
              return this.apiProjectsService.projectsExists([{
                name: name,
                primaryAssociationId: client.id,
                primaryAssociationType: DMS.toApiItemType(DMS.ItemType.Client),
                processingYear: year,
                productType: 'DMSClientFolder'
              }]);
            case 3:
              response = _context25.sent;
              result = response.body[0];
              return _context25.abrupt("return", !!result.exists && new DMS.ContainerKey(result.project.id, DMS.ItemType.Project));
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function projectExists(_x54, _x55) {
        return _projectExists.apply(this, arguments);
      }
      return projectExists;
    }()
  }, {
    key: "getAllSharesByType",
    value: function () {
      var _getAllSharesByType = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(type, keys) {
        var ids, response, shareContainers;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              ids = keys.map(function (key) {
                return key.id;
              });
              response = type === DMS.ItemType.Folder ? this.apiFoldersService.getPermissionsAsync({
                containerIds: ids
              }) : this.apiProjectsService.getPermissionsAsync({
                containerIds: ids
              });
              _context26.next = 4;
              return response;
            case 4:
              shareContainers = _context26.sent.body;
              return _context26.abrupt("return", shareContainers.reduce(function (map, containerShare) {
                var _containerShare$conta;
                assertRequired(containerShare.id, 'ContainerPermissionV1Dto.id', true, containerShare);
                var shares = ((_containerShare$conta = containerShare.containerPermissions) !== null && _containerShare$conta !== void 0 ? _containerShare$conta : []).map(modelMapper.share);
                map.set(containerShare.id, shares);
                return map;
              }, new Map()));
            case 6:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function getAllSharesByType(_x56, _x57) {
        return _getAllSharesByType.apply(this, arguments);
      }
      return getAllSharesByType;
    }()
  }]);
}(ItemService);
export { ContainerService as default };
